export const localStorageUserKey = '43thuwvis32fsErko_user_data'

export const secretUUID = 'djwa32rFWE4nwdwaFFA42f'
